export default __webpack_public_path__ + "static/media/OrangeMango.bd96e852.png";